import * as marietta from '../..';
import { BUILDING_TYPE_MANSION } from '../Constants';
import { SVGSprite } from '../flash/display';
import { Stage } from '../model';

class ItemControllerFitting {
  target: marietta.webcad.item.MonicaObject;

  dragObjL: marietta.webcad.control.parts.ControlPicker;

  dragObjR: marietta.webcad.control.parts.ControlPicker;

  btnDelete: marietta.webcad.control.parts.ButtonGarbage;

  btnReverse: marietta.webcad.control.parts.ButtonReverse;

  btnDragger: marietta.webcad.control.parts.DraggerMobile;

  allBox: marietta.webcad.control.parts.BoundingBox;

  rotator: marietta.webcad.control.parts.ControlRotatorFitting;

  startPoint: marietta.core.Point;

  x: number;

  y: number;

  rotation: number;

  width: number;

  height: number;

  dragStartPoint: marietta.core.Point;

  public spt: SVGSprite;

  public emptySpt: SVGSprite;

  guideView: SVGElement;

  fittingGuide: marietta.webcad.item.parts.FittingGuide;

  previousInfo:marietta.webcad.collection.ItemInfoCollection;

  /**
   * コンストラクタ
   */
  constructor(_target: marietta.webcad.item.MonicaObject) {
    // ターゲット
    this.target = _target;
    // 作成する階
    const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.target.itemInfo.floor, true) as marietta.webcad.layer.FloorShitaeLayer;
    // 形状の生成
    const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    viewObj.id = 'controller';

    // 全体のボックス
    this.allBox = new marietta.webcad.control.parts.BoundingBox(viewObj);
    // 回転
    this.rotator = new marietta.webcad.control.parts.ControlRotatorFitting(viewObj);
    this.rotator.rotateStartFunc = this.rotateStart;
    this.rotator.rotateFunc = this.rotate;
    this.rotator.rotateEndFunc = this.rotateEnd;

    // ピッカー
    this.dragObjL = new marietta.webcad.control.parts.ControlPicker(viewObj, 'L');
    this.dragObjL.moveFunc = this.onMoveControlPicker;
    this.dragObjL.moveEndFunc = this.onMoveEndControlPicker;
    this.dragObjR = new marietta.webcad.control.parts.ControlPicker(viewObj, 'R');
    this.dragObjR.moveFunc = this.onMoveControlPicker;
    this.dragObjR.moveEndFunc = this.onMoveEndControlPicker;
    // モバイル
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      // 削除ボタン
      this.btnDelete = new marietta.webcad.control.parts.ButtonGarbage(viewObj, this.target);
      // 反転ボタン
      this.btnReverse = new marietta.webcad.control.parts.ButtonReverse(viewObj, this.target);
      // 移動軸
      this.btnDragger = new marietta.webcad.control.parts.DraggerMobile(viewObj, this.target);
      this.btnDragger.dragFunc = this.onMoveDragger;
      this.btnDragger.dragEndFunc = this.onMoveEndDragger;
    }

    // エンドアイテムが決まっている場合は、サイズ変更できないので、非表示にする
    if (!this.target.itemInfo.isWhiteItem()) {
      this.dragObjL.hide();
      this.dragObjR.hide();
    }

    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      this.guideView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      this.guideView.setAttribute('id', `${this.target.itemInfo.id}_${this.target.itemInfo.guid}fittingGuide`);
      this.fittingGuide = new marietta.webcad.item.parts.FittingGuide(this.guideView);
      const item = (this.target as marietta.webcad.item.Fitting);
      const scale = marietta.webcad.WebCADGlobal.scaleSize;
      let y = -this.fittingGuide.guideLineY * (1 / scale) - (this.fittingGuide.guideLinePadding * scale);
      if (item.snapWall != null) {
        if (item.snapWall.parentObj.spt === undefined || item.snapWall.parentObj.spt === null) {
          item.snapToWall();
        } else {
          if (item.snapWall.startDot.x > item.snapWall.endDot.x) {
            y = this.fittingGuide.guideLineY * (1 / scale) + (this.fittingGuide.guideLinePadding * scale);
          }
          $(this.fittingGuide.viewObj).show();
        }
      } else {
        $(this.fittingGuide.viewObj).hide();
      }
      this.fittingGuide.parentObj = this.target;
      const fittingGuideWidth = Math.abs(this.target.itemInfo.width);
      this.fittingGuide.firstDot = new marietta.core.Point(-fittingGuideWidth / 2, y);
      this.fittingGuide.secondDot = new marietta.core.Point(fittingGuideWidth / 2, y);
      viewObj.appendChild(this.fittingGuide.viewObj);
      if (item.snapWall != null) {
        const wallStartPoint = new marietta.core.Point(Math.round((this.target as marietta.webcad.item.Fitting).snapWall.startDot.x) + Math.round((this.target as marietta.webcad.item.Fitting).snapWall.parentObj.itemInfo.x), Math.round((this.target as marietta.webcad.item.Fitting).snapWall.startDot.y) + Math.round((this.target as marietta.webcad.item.Fitting).snapWall.parentObj.itemInfo.y));
        const wallEndPoint = new marietta.core.Point(Math.round((this.target as marietta.webcad.item.Fitting).snapWall.endDot.x) + Math.round((this.target as marietta.webcad.item.Fitting).snapWall.parentObj.itemInfo.x), Math.round((this.target as marietta.webcad.item.Fitting).snapWall.endDot.y) + Math.round((this.target as marietta.webcad.item.Fitting).snapWall.parentObj.itemInfo.y));
        let fittingStartPoint = marietta.webcad.util.WebCADUtil.getPointWithAngleAndDistance(new marietta.core.Point(this.target.itemInfo.x, this.target.itemInfo.y), this.target.itemInfo.rotation, this.target.itemInfo.width / 2);
        fittingStartPoint = new marietta.core.Point(Math.round(fittingStartPoint.x), Math.round(fittingStartPoint.y));
        let fittingEndPoint = marietta.webcad.util.WebCADUtil.getPointWithAngleAndDistance(new marietta.core.Point(this.target.itemInfo.x, this.target.itemInfo.y), this.target.itemInfo.rotation, -this.target.itemInfo.width / 2);
        fittingEndPoint = new marietta.core.Point(Math.round(fittingEndPoint.x), Math.round(fittingEndPoint.y));
        const fittingCenterPoint = new marietta.core.Point(Math.round(this.target.itemInfo.x), Math.round(this.target.itemInfo.y));
        if (!((marietta.webcad.util.WebCADUtil.isOnLine(wallStartPoint, wallEndPoint, fittingStartPoint) && marietta.webcad.util.WebCADUtil.isOnLine(wallStartPoint, wallEndPoint, fittingCenterPoint)) || (marietta.webcad.util.WebCADUtil.isOnLine(wallStartPoint, wallEndPoint, fittingEndPoint) && marietta.webcad.util.WebCADUtil.isOnLine(wallStartPoint, wallEndPoint, fittingCenterPoint)))) {
          $(this.fittingGuide.viewObj).hide();
        }
      }
    }

    if (this.target.itemInfo.lock) {
      this.hideToolTips();
    } else {
      this.showToolTips();
    }

    tarLayer.viewObj.appendChild(viewObj);
    this.spt = new SVGSprite(viewObj);
    // ターゲットに合わせてサイズ変更
    this.resizeToTarget();
    this.updateGuideView();
  }

  updateGuideView() {
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      const scale = marietta.webcad.WebCADGlobal.scaleSize;
      const item = (this.target as marietta.webcad.item.Fitting);
      let y = -this.fittingGuide.guideLineY * (1 / scale) - (this.fittingGuide.guideLinePadding * scale);
      if (item.snapWall != null) {
        if (item.snapWall.startDot.x > item.snapWall.endDot.x) {
          y = this.fittingGuide.guideLineY * (1 / scale) + (this.fittingGuide.guideLinePadding * scale);
        }
        $(this.fittingGuide.viewObj).show();
      } else {
        $(this.fittingGuide.viewObj).hide();
      }
      // ロック状態のチェック項目
      if (this.target.itemInfo.lock) {
        $(this.fittingGuide.viewObj).hide();
      }
      this.fittingGuide.parentObj = this.target;
      const fittingGuideWidth = Math.abs(this.target.itemInfo.width);
      this.fittingGuide.firstDot = new marietta.core.Point(-fittingGuideWidth / 2, y);
      this.fittingGuide.secondDot = new marietta.core.Point(fittingGuideWidth / 2, y);
      if (item.snapWall != null) {
        const wallStartPoint = new marietta.core.Point(Math.round((this.target as marietta.webcad.item.Fitting).snapWall.startDot.x) + Math.round((this.target as marietta.webcad.item.Fitting).snapWall.parentObj.itemInfo.x), Math.round((this.target as marietta.webcad.item.Fitting).snapWall.startDot.y) + Math.round((this.target as marietta.webcad.item.Fitting).snapWall.parentObj.itemInfo.y));
        const wallEndPoint = new marietta.core.Point(Math.round((this.target as marietta.webcad.item.Fitting).snapWall.endDot.x) + Math.round((this.target as marietta.webcad.item.Fitting).snapWall.parentObj.itemInfo.x), Math.round((this.target as marietta.webcad.item.Fitting).snapWall.endDot.y) + Math.round((this.target as marietta.webcad.item.Fitting).snapWall.parentObj.itemInfo.y));
        let fittingStartPoint = marietta.webcad.util.WebCADUtil.getPointWithAngleAndDistance(new marietta.core.Point(this.target.itemInfo.x, this.target.itemInfo.y), this.target.itemInfo.rotation, this.target.itemInfo.width / 2);
        fittingStartPoint = new marietta.core.Point(Math.round(fittingStartPoint.x), Math.round(fittingStartPoint.y));
        let fittingEndPoint = marietta.webcad.util.WebCADUtil.getPointWithAngleAndDistance(new marietta.core.Point(this.target.itemInfo.x, this.target.itemInfo.y), this.target.itemInfo.rotation, -this.target.itemInfo.width / 2);
        fittingEndPoint = new marietta.core.Point(Math.round(fittingEndPoint.x), Math.round(fittingEndPoint.y));
        const fittingCenterPoint = new marietta.core.Point(Math.round(this.target.itemInfo.x), Math.round(this.target.itemInfo.y));
        if (!((marietta.webcad.util.WebCADUtil.isOnLine(wallStartPoint, wallEndPoint, fittingStartPoint) && marietta.webcad.util.WebCADUtil.isOnLine(wallStartPoint, wallEndPoint, fittingCenterPoint)) || (marietta.webcad.util.WebCADUtil.isOnLine(wallStartPoint, wallEndPoint, fittingEndPoint) && marietta.webcad.util.WebCADUtil.isOnLine(wallStartPoint, wallEndPoint, fittingCenterPoint)))) {
          $(this.fittingGuide.viewObj).hide();
        }
      }
    }
  }

  /**
   * ターゲットに合わせて各種パーツリサイズ
   */
  resizeToTarget() {
    // 位置合わせ
    this.syncMeToTarget();
    // 一度回転角度を戻してサイズを計測する
    const motoRot: number = this.target.itemInfo.rotation;
    this.target.rotate(0);

    // SVGSpriteのwidth/heightに書き換え
    // k.kubonaka WEBCAD-1058対応
    const width: number = Math.abs(this.target.itemInfo.width);
    const height: number = marietta.webcad.WebCADGlobal.WALL_WIDTH;

    // ピッカー
    this.dragObjL.move(-width / 2, 0);
    this.dragObjR.move(width / 2, 0);

    // 回転
    this.rotator.move(-6.5, -marietta.webcad.WebCADGlobal.WALL_WIDTH / 2 - 25);

    // アイコンボタンの位置更新
    this.updateIconButtons();

    // 全体Box
    this.allBox.resize({ width, height });
    this.allBox.move(this.dragObjL.x + (this.dragObjR.x - this.dragObjL.x) / 2, 0);

    // 回転角度を元に戻す
    this.target.rotate(motoRot);

    this.rotation = motoRot;
    this.updateTransforms();
  }

  /**
   * ターゲットにシンクロする
   * ※アイテムのドラッグ時に呼び出される
   */
  syncMeToTarget() {
    this.x = this.target.itemInfo.x;
    this.y = this.target.itemInfo.y;
    this.rotation = this.target.itemInfo.rotation;
    this.updateTransforms();
  }

  /**
   * アイコンボタンの更新
   */
  updateIconButtons() {
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      // 削除ボタン
      this.btnDelete.move(this.dragObjR.x + 35, this.dragObjR.y);
      // 反転ボタン
      this.btnReverse.move(this.dragObjL.x - 35, this.dragObjL.y);
      // 移動軸
      this.btnDragger.move(this.dragObjL.x + (this.dragObjR.x - this.dragObjL.x) / 2, 35);
    }
  }

  /**
   * 回転の開始（位置のリセット）
   * @param MouseEvent
   */
  rotateStart = () => {
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      $(this.fittingGuide.viewObj).hide();
    }
    this.x = this.target.itemInfo.x;
    this.y = this.target.itemInfo.y;
    this.updateTransforms();

    // k.kubonaka WEBCAD-1058対応
    const width: number = Math.abs(this.target.itemInfo.width);

    // ピッカー
    this.dragObjL.move(-width / 2, 0);
    this.dragObjR.move(width / 2, 0);
    this.rotator.move(-6.5, -marietta.webcad.WebCADGlobal.WALL_WIDTH / 2 - 25);

    this.allBox.move(this.dragObjL.x + (this.dragObjR.x - this.dragObjL.x) / 2, 0);

    // 文字を消す
    this.target.hideChildren();
  };

  /**
   * 回転する
   * @param MouseEvent
   */
  rotate = (e: MouseEvent) => {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfRotate()) return;

    // const rect = this.target.viewObj.getBoundingClientRect();
    const firstPoint: marietta.core.Point = new marietta.core.Point(this.target.itemInfo.x, this.target.itemInfo.y);
    const newPoint: marietta.core.Point = marietta.webcad.util.WebCADUtil.convertToLocalPoint(e);
    const secondPoint: marietta.core.Point = new marietta.core.Point(newPoint.x, newPoint.y);

    // レイヤーのスケーリング分を考慮
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    secondPoint.x -= Stage.offsetX - marietta.webcad.WebCADGlobal.OUTERFRAME_LEFT_FRAME_WIDTH;
    secondPoint.y -= Stage.offsetY - marietta.webcad.WebCADGlobal.OUTERFRAME_HEADER_HEIGHT;
    secondPoint.x /= root.scaleX;
    secondPoint.y /= root.scaleY;

    // 角度
    const radian: number = Math.atan2((firstPoint.x - secondPoint.x), (firstPoint.y - secondPoint.y));
    let angle: number = -radian / (Math.PI / 180) + 360 - 180;
    if (angle % 45 > 15 && angle % 45 < 30) {
      this.rotator.showAssist(false);
    } else {
      this.rotator.showAssist(true);
      angle = Math.round(angle / 45) * 45;
    }

    this.rotation = angle;
    this.updateTransforms();
    // ターゲットを回転
    this.target.rotate(angle);

    if (this.emptySpt) {
      this.emptySpt.setEmptyParam(this.target.spt);
    }
  }

  /**
   * 回転の終了（位置のリセット）
   * @param MouseEvent
   */
  rotateEnd = () => {
    (this.target as marietta.webcad.item.Fitting).isCustomRotate = true;
    this.target.updateChildren();
    // 文字を消す
    this.target.showChildren();
    this.updateGuideView();
  };

  /**
   * コントロールピッカーが移動された
   */
  onMoveControlPicker = (e: MouseEvent, target: marietta.webcad.control.parts.ControlPicker) => {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfResize()) return;

    // 開始時のアイテム場所保持
    if (this.startPoint === undefined) {
      // this.startPoint = new marietta.core.Point( this.target.itemInfo.x, this.target.itemInfo.y );

      if (this.emptySpt === undefined) {
        /*
          本来はtarget.sptのmouseX/mouseYで取得できるが、
          拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
          そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
          取得している。
        */
        this.emptySpt = new SVGSprite(null, true);
        this.emptySpt.setEmptyParam(this.target.spt);
        this.target.spt.parent.addChild(this.emptySpt);
      }

      this.startPoint = new marietta.core.Point(
        this.emptySpt.mouseX * this.target.spt.scaleX,
        this.emptySpt.mouseY * this.target.spt.scaleY,
      );
    }
    const newPoint: marietta.core.Point = new marietta.core.Point(
      this.emptySpt.mouseX * this.target.spt.scaleX,
      this.emptySpt.mouseY * this.target.spt.scaleY,
    );

    // アイテムの角度分、座標変換を行う
    const r: number = -((this.target.spt.rotation % 360) / 180) * Math.PI;
    const xx: number = newPoint.x * Math.cos(r) - newPoint.y * Math.sin(r);
    const yy: number = newPoint.x * Math.sin(r) + newPoint.y * Math.cos(r);
    newPoint.x = xx;
    newPoint.y = yy;

    const snapUnit: number = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
    if (target === this.dragObjL && this.dragObjR.x - snapUnit <= newPoint.x) {
      newPoint.x = this.dragObjR.x - snapUnit;
    }
    if (target === this.dragObjR && this.dragObjL.x + snapUnit >= newPoint.x) {
      newPoint.x = this.dragObjL.x + snapUnit;
    }
    target.moveX(newPoint.x);

    // ドラッグ範囲
    this.rotator.move(-(this.dragObjL.x + (this.dragObjR.x - this.dragObjL.x) / 2) - 6.5, -marietta.webcad.WebCADGlobal.WALL_WIDTH / 2 - 25);

    // 矩形のサイズ変更
    const rect = {
      x: this.dragObjL.x + (this.dragObjR.x - this.dragObjL.x) / 2, y: 0, width: (this.dragObjR.x - this.dragObjL.x), height: marietta.webcad.WebCADGlobal.WALL_WIDTH,
    };
    this.allBox.resize(rect);
    this.allBox.move(this.dragObjL.x + (this.dragObjR.x - this.dragObjL.x) / 2, 0);

    // ターゲットのリサイズ
    this.resizeTarget(target);
    this.updateGuideView();
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isPC) {
        marietta.webcad.WebCADGlobal.itemManager.currentItem = this.target;
      } else if (ua.isMobile || ua.isTablet) {
        $(this.fittingGuide.viewObj).hide();
      }
    }

    // アイコンボタンの位置更新
    this.updateIconButtons();
  }

  /**
   * コントロールピッカーのドラッグ終了
   */
  onMoveEndControlPicker = () => {
    this.startPoint = null;
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      if (ua.isMobile || ua.isTablet) {
        marietta.webcad.WebCADGlobal.itemManager.currentItem = this.target;
        $(this.fittingGuide.viewObj).show();
      }
    }
    if (this.target.itemInfo.id === 'fit01_01' || this.target.itemInfo.id === 'fit01_03' || this.target.itemInfo.id === 'fit02_01') {
      marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
    }
    this.target.itemInfo.updateArea();
    marietta.webcad.WebCADGlobal.quotationItemList.createData();
  }

  /**
   * ターゲットのリサイズ
   * */
  resizeTarget(picker: marietta.webcad.control.parts.ControlPicker) {
    // 現在のサイズを見て、pickerの位置を調整する
    let newW: number;
    const snapUnit: number = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;

    switch (picker) {
      case this.dragObjL:
        newW = Math.round(((this.dragObjR.x - this.dragObjL.x) * this.spt.scaleX) / snapUnit) * snapUnit;
        if (newW < snapUnit) newW = snapUnit;
        this.dragObjL.x = this.dragObjR.x - (newW * 1) / this.spt.scaleX;
        break;
      case this.dragObjR:
        newW = Math.round(((this.dragObjR.x - this.dragObjL.x) * this.spt.scaleX) / snapUnit) * snapUnit;
        if (newW < snapUnit) newW = snapUnit;
        this.dragObjR.x = this.dragObjL.x + (newW * 1) / this.spt.scaleX;
        break;
      default: break;
    }
    this.dragObjL.updateTranslate();
    this.dragObjR.updateTranslate();

    // 矩形のサイズ変更
    const rect = {
      x: this.dragObjL.x + (this.dragObjR.x - this.dragObjL.x) / 2, y: 0, width: (this.dragObjR.x - this.dragObjL.x), height: marietta.webcad.WebCADGlobal.WALL_WIDTH,
    };
    this.allBox.resize(rect);
    this.allBox.move(this.dragObjL.x + (this.dragObjR.x - this.dragObjL.x) / 2, 0);

    // 回転角度をなくして計算
    const motoRot: number = this.rotation;
    this.rotation = 0;
    this.target.rotate(0);

    // 中心点を計算
    const p1: marietta.core.Point = new marietta.core.Point(this.dragObjL.x, this.dragObjL.y);
    const p2: marietta.core.Point = new marietta.core.Point(this.dragObjR.x, this.dragObjR.y);

    const r: number = ((motoRot % 360) / 180) * Math.PI;
    let xx: number = p1.x * Math.cos(r) - p1.y * Math.sin(r);
    let yy: number = p1.x * Math.sin(r) + p1.y * Math.cos(r);
    p1.x = xx;
    p1.y = yy;

    xx = p2.x * Math.cos(r) - p2.y * Math.sin(r);
    yy = p2.x * Math.sin(r) + p2.y * Math.cos(r);
    p2.x = xx;
    p2.y = yy;

    const genten: marietta.core.Point = marietta.core.Point.interpolate(p1, p2, 0.5);

    genten.x += this.spt.x;
    genten.y += this.spt.y;

    // サイズ変更
    // ピクセル単位に変更する
    (this.target as marietta.webcad.item.Fitting).itemInfo.use_mm = false;
    (this.target as marietta.webcad.item.Fitting).changeSize(newW, 0);
    (this.target as marietta.webcad.item.Fitting).move(genten.x, genten.y);

    // 回転角度を
    this.rotation = motoRot;
    this.target.rotate(motoRot);
    this.target.updateChildren();
  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    this.spt.x = this.x;
    this.spt.y = this.y;
    this.spt.rotation = this.rotation;
    this.spt.update();
  }

  /**
   * ピッカーのサイズ更新
   */
  public updatePickers(): void {
    this.rotator.updateTranslate();
    this.dragObjL.updateTranslate();
    this.dragObjR.updateTranslate();
    // モバイルの場合
    if (this.btnDelete != null) {
      this.btnDelete.updateTranslate();
      this.btnReverse.updateTranslate();
      this.btnDragger.updateTranslate();
    }
  }

  /**
 * コントロールピッカーが移動された
 */
  onMoveDragger = () => {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfMove()) return;
    // 開始時のアイテム場所保持
    if (this.dragStartPoint === undefined || this.dragStartPoint === null) {
      if (this.emptySpt === undefined) {
        /*
          本来はtarget.sptのmouseX/mouseYで取得できるが、
          拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
          そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
          取得している。
        */
        this.emptySpt = new SVGSprite(null, true);
        this.emptySpt.setEmptyParam(this.btnDragger.spt);
        this.target.spt.parent.addChild(this.emptySpt);
      }
      // アイテムの元位置
      this.dragStartPoint = new marietta.core.Point(
        this.emptySpt.mouseX * this.target.spt.scaleX,
        this.emptySpt.mouseY * this.target.spt.scaleY,
      );

      // ドラッグの開始位置
      this.dragStartPoint = new marietta.core.Point(
        this.target.spt.mouseX * this.target.spt.scaleX,
        this.target.spt.mouseY * this.target.spt.scaleY,
      );
    }
    const newPoint: marietta.core.Point = new marietta.core.Point(
      marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX,
      marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY,
    );
    // const moveX: number = newPoint.x - this.dragStartPoint.x;
    // const moveY: number = newPoint.y - this.dragStartPoint.y;
    const snapPoint: marietta.core.Point = ItemControllerFitting.getSnapPoint(newPoint);
    // ターゲットの移動
    this.target.move(snapPoint.x, snapPoint.y);
    // ターゲットに吸着
    this.syncMeToTarget();
  }

  /**
   * グリッドに吸い付く
   * */
  static getSnapPoint(motoPoint: marietta.core.Point): marietta.core.Point {
    const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
    const newPoint: marietta.core.Point = new marietta.core.Point(motoPoint.x, motoPoint.y);
    newPoint.x = Math.round(newPoint.x / snapUnit) * snapUnit;
    newPoint.y = Math.round(newPoint.y / snapUnit) * snapUnit;
    return newPoint;
  }

  /**
   * コントロールピッカーのドラッグ終了
   */
  onMoveEndDragger = () => {
    this.dragStartPoint = null;
    if (this.emptySpt && this.emptySpt.parent) {
      this.emptySpt.parent.removeChild(this.emptySpt);
      this.emptySpt = null;
    }
    // マウスアップの挙動
    marietta.webcad.WebCADGlobal.itemManager.currentItem = this.target;
  }

  /**
   * ツールチップを非表示
   */
  hideToolTips() {
    // モバイル
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      this.btnDelete.hide();
      this.btnDragger.hide();
      this.btnReverse.hide();
    }
    this.rotator.hide();
    this.dragObjL.disablePicker();
    this.dragObjR.disablePicker();
  }

  /**
   * ツールチップを表示する
   */
  showToolTips() {
    // モバイル
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      this.btnDelete.show();
      if (!this.target.isCapableOfMove()) {
        this.btnDragger.hide();
      } else {
        this.btnDragger.show();
      }
      this.btnReverse.show();
    }
    this.rotator.show();
    this.dragObjL.enablePicker();
    this.dragObjR.enablePicker();
  }
}
export default ItemControllerFitting;
